export const SIDEBAR_WIDTH = 232
export const SIDEBAR_COLLAPSED_WIDTH = 64
export const TOP_BAR_HEIGHT = 48

export const SIDEBAR_TRANSITION_DURATION_MS = 440
export const SIDEBAR_TRANSITION_EASING = 'cubic-bezier(0.65, 0, 0.35, 1)'
export const COLUMN_WITH_SMALL_ICON_WIDTH = 52
export const COLUMN_WITH_MEDIUM_ICON_WIDTH = 62
export const COLUMN_WITH_LARGE_ICON_WIDTH = 68
export const FIELD_WIDTH = 220
export const AUTOCOMPLETE_FIELD_WIDTH = 300
export const SEARCH_FIELD_WIDTH = 300
